











































































































































































































































import Vue from 'vue'
import ProgressCircular from '@/components/ProgressCircular.vue'
import { TranslateResult } from 'vue-i18n'
import { SecurityArea, SecurityComponent, SnackbarStateEnum } from '@/types/enums'
import WebReportTransferDialog from '@/components/master-data/address/WebReportTransferDialog.vue'
import * as securityService from '@/services/security-service'
import NumberField from '@/components/NumberField.vue'


interface ComponentData {
  showTransferDialog: boolean
  loading: boolean
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string

  global: boolean
  direction: boolean
  date: string
  time: string
  project: string
  contactPerson: string
  client: string
  billingAddress: string
  consumablesList: any[]
  workList: any[]
  selectedWork: any[]
  contacts: any[]
  table1: any[]
  table2: any[]
  table3: any[]
  table4: any[]
  checked: boolean
  posted: boolean
  settle: boolean
  next: boolean
  done: boolean
}

export default Vue.extend({
  name: 'WebReportArbeitsrapport',

  components: {
    NumberField,
    ProgressCircular,
    WebReportTransferDialog
  },

  props: {
    show: Boolean,
    selectedProjectId: Number,
    selectedProjectNumber: String,
  },

  data (): ComponentData {
    return {
      showTransferDialog: false,
      loading: false,
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',

      global: false,
      direction: false,
      date: 'Dienstag / 06.08.2025',
      time: '08:00-11:00',
      project: 'Fotorotar Fasadenreinigung <br> Gewerbestrasse <br> 18 8132 Egg bei Zürich',
      contactPerson: 'Martin Mustermann <br> Hauswart <br> 078 123 45 67',
      client: 'Eva Cronauer <br> SYZ AG <br> Gewerbestrasse 12 <br> 8132 Egg bei Zürich',
      billingAddress: 'SYZ AG <br> Gewerbestrasse 12 <br> Postfach 123 <br> 8132 Egg bei Zürich',
      consumablesList: ['Reinigungsmittel EXTRA', 'Hochdruckreiniger HRX102', 'Anfahrt'],
      workList: ['Arbeit 1', 'Arbeit 2', 'Arbeit 3', 'Arbeit 4', 'Arbeit 5', 'Arbeit 6',],
      selectedWork: [],
      contacts: [
        { name: 'Aargau', phone: '056 246 29 29', fax: '056 246 29 29', mail: 'ag@agr-reinigungen.ch' },
        { name: 'Basel', phone: '056 246 29 29', fax: '056 246 29 29', mail: 'bs@agr-reinigungen.ch' },
        { name: 'Schwyz', phone: '056 246 29 29', fax: '056 246 29 29', mail: 'sz@agr-reinigungen.ch' },
        { name: 'Zürich', phone: '056 246 29 29', fax: '056 246 29 29', mail: 'zh@agr-reinigungen.ch' },
      ],
      table1: [
        { id: 1, date: '06.08.2025', people: 2, perHour: '1.0', totalHours: '2.0' },
        { id: 2, date: '06.08.2025', people: 3, perHour: '2.5', totalHours: '7.5' },
        { id: 3, date: '', people: '', perHour: '', totalHours: '' },
        { id: 4, date: '', people: '', perHour: '', totalHours: '' },
        { id: 5, date: '', people: '', perHour: '', totalHours: '' },
        { id: 6, date: '', people: '', perHour: '', totalHours: '' },
      ],
      table2: [
        { id: 1, consumables: 'Reinigungsmittel EXTRA', unit: 'Stk.', hour: 1, price: '30.50' },
        { id: 2, consumables: 'Hochdruckreiniger HRX102', unit: 'Stk.', hour: 5, price: '40' },
        { id: 3, consumables: 'Anfahrt', unit: 'km', hour: 18, price: '90' },
        { id: 4, consumables: '', unit: '', std: '', price: '' },
      ],
      table3: [
        { id: 7, label: 'Zuschlag für', people: 2, perHour: '0.5', totalHours: '1.0' },
        { id: 8, label: 'Überzeiten und', people: '', perHour: '', totalHours: '' },
        { id: 9, label: 'Sonntagsarbeiten', people: '', perHour: '', totalHours: '' },
      ],
      table4: [
        { id: 1, piece: 1, m3: null, count: 1, description: 10.00 },
        { id: 2, piece: null, m3: null, count: null, description: null }
      ],
      checked: false,
      posted: false,
      settle: false,
      next: false,
      done: false,
    }
  },

  watch: {

  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    showTransferButton (): boolean {
      return securityService.isVisible(SecurityArea.Addresses, SecurityComponent.TransferButton)
    },

    disableTransferButton (): boolean {
      return securityService.isDisabled(SecurityArea.Addresses, SecurityComponent.TransferButton)
    },

    getTotalPeople (): any {
      return this.table1.reduce((accumulator: any, currentItem: any) => {
        return accumulator + currentItem.people;
      }, 0)
    },

    getTotalPerHour (): any {
      return this.table1.reduce((accumulator: any, currentItem: any) => {
        return accumulator + + currentItem.perHour;
      }, 0)
    },

    getTotalTotalHours (): any {
      return this.table1.reduce((accumulator: any, currentItem: any) => {
        return accumulator + + currentItem.totalHours;
      }, 0)
    }
  },

  methods: {
    onTransferClick (): void {
      /*this.showTransferDialog = true*/
    },

    onCloseTransferDialogClick (): void {
      /*this.showTransferDialog = false*/
    },

    transferSaved (): void {
      /*this.showTransferDialog = false
      this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
      this.snackbarState = SnackbarStateEnum.Success
      this.showSnackbar = true*/
    },

    transferError (): void {
      /*this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
      this.snackbarState = SnackbarStateEnum.Error
      this.showSnackbar = true*/
    },

    onCloseDialog (): void {
      this.$emit('close')
    },

    onSaveClick (): void {
      /*for (const item in this.webReportPayload) {
        if(this.webReportPayload[item] === true) {
          this.webReportPayload[item] = "Ja"
        } else if(this.webReportPayload[item] === false) {
          this.webReportPayload[item] = ""
        }
      }

      const payload: any =  {
        AddressId: this.selectedAddressId,
        FormName: "Pflichtenheft",
        Values: this.webReportPayload
      }

      this.saveWebReport(payload)*/
    },

    async saveWebReport (payload: any): Promise<void> {
      /*try {
        this.loading = true
        const response: any = await this.$store.dispatch(SAVE_ADDRESS_WEB_REPORT, payload)
        this.loading = false
        if(response.IsError) {
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
          this.snackbarState = SnackbarStateEnum.Error
          this.showSnackbar = true
        } else {
          this.$emit('saved')
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }*/
    },

    setData (data: any): void {

    },

    async fetchData (): Promise<void> {
      /*try {
        this.loading = true
        const response: any = await this.$store.dispatch(FETCH_ADDRESS_WEB_REPORT, this.selectedProjectId)
        this.loading = false
        if(response) {
          for (const key in response) {
            if(response[key] === 'Off') {
              response[key] = ''
            }
          }
          this.setData(response)
        }
      } catch (e) {
        this.loading = false
      }*/
    }
  },

  mounted () { }
})
